import React from 'react';
import { Link } from 'react-router-dom';

const Hero: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="/images/loomhero.avif"
          alt="Textile loom hero background"
          className="w-full h-full object-cover"
        />
        {/* Overlay for better text readability */}
        <div className="absolute inset-0 bg-gradient-to-br from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="container-custom text-center relative z-10">
        <div className="max-w-3xl mx-auto">
          {/* Smaller Glassmorphism Card Container */}
          <div className="backdrop-blur-xl bg-white/15 border border-white/25 rounded-2xl p-6 md:p-8 shadow-2xl">
            {/* Main Headline */}
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-6 animate-fade-in drop-shadow-2xl">
              Premium Quality Textiles
            </h1>
            
            {/* Tagline */}
            <p className="text-lg md:text-xl lg:text-2xl text-white mb-6 font-medium animate-slide-up drop-shadow-xl">
              Where Design Meets Sustainability
            </p>
            
            {/* Description */}
            <p className="text-base md:text-lg text-white mb-8 max-w-2xl mx-auto leading-relaxed animate-slide-up drop-shadow-lg">
              Crafting premium textiles that blend timeless elegance with innovative sustainability. 
              From upholstery to apparel, we weave stories into every fabric.
            </p>
            
            {/* Call to Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-slide-up">
              <Link to="/collections" className="px-8 py-3 bg-gradient-to-r from-emerald-600 to-teal-600 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 border border-emerald-500/30">
                Explore Collections
              </Link>
              <Link to="/about" className="px-8 py-3 bg-gradient-to-r from-white/20 to-white/10 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 border border-white/30 backdrop-blur-sm">
                Our Story
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Elements - No glassmorphism */}
      <div className="absolute bottom-8 left-8 hidden lg:block">
        <div className="w-24 h-24 border-2 border-white/20 rotate-45 rounded-2xl"></div>
      </div>
      <div className="absolute top-20 right-12 hidden lg:block">
        <div className="w-16 h-16 bg-white/5 rounded-full border border-white/20"></div>
      </div>
    </section>
  );
};

export default Hero;
